const cdn =
  "https://cdngarenanow-a.akamaihd.net/gstaticid/FF_ME/iphone_giveaway/";

export const preloadData = [
  // fonts
  cdn + "fonts/AGENCYFB-REGULAR.ttf",
  cdn + "fonts/AGENCYFB-BOLD.ttf",
  cdn + "fonts/Gunar.ttf",
  cdn + "fonts/Gunar Bold.ttf",

  // slicing
  cdn + "puff.svg",
  cdn + "scape.png",
  cdn + "BG_main.jpg",
  cdn + "header.png",
  cdn + "Dialog.png",
  cdn + "toast_bg.png",
  cdn + "img_iphone_kv.png",
  cdn + "img_wheel_arrow.png",
  cdn + "IMG_wheel.png",
  cdn + "Mission_bar.png",
  cdn + "Terms_and_condition_check.png",
  cdn + "Terms_and_condition_checkboc.png",

  cdn + "BG_share.jpg",
  cdn + "BG_portrait.png",
  cdn + "Img_headline_text.png",
  cdn + "Img_headline_text_portrait.png",
];
